import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router';
import auth from '../../auth';
import Login from '../Login/Login';
import ChangePassword from '../Login/ChangePassword';
import Home from '../Home/Home';
import Scenarios from '../Scenarios/Scenarios';
import Exercises from '../Exercises/Exercises';
import ExerciseCreate from '../ExerciseCreate/ExerciseCreate';
import Exercise from '../Exercise/Exercise';
import ExerciseWaitingRoom from '../ExerciseWaitingRoom/ExerciseWaitingRoom';
import ExerciseRun from '../ExerciseRun/ExerciseRun';
import MutualAid from '../MutualAid/MutualAid';
import Users from '../Users/Users';
import User from '../User/User';
import Companies from '../Companies/Companies';
import Company from '../Company/Company';
import BlackList from '../BlackList/BlackList';
import Help from '../Help/Help';
import NotFound from '../NotFound/NotFound';

import styles from './Layout.module.css';

// Protected Route Component - replaces requireAuth
function ProtectedRoute({ children }) {
  const location = useLocation();
  
  if (!auth.loggedIn()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return children;
}

// Public Only Route Component - replaces checkLogin
function PublicOnlyRoute({ children }) {
  if (auth.loggedIn()) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

// Logout Component
function Logout() {
  auth.logout(() => {});
  return <Navigate to="/login" replace />;
}

// WebBuilder Component
function WebBuilder() {
  return (
    <iframe 
      src="https://simsushare-testing.web.app/" 
      title="SUS Builder" 
      className={styles['builder-iframe']} 
    />
  );
}

export default function LayoutRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Home />} />
      <Route 
        path="/login" 
        element={
          <PublicOnlyRoute>
            <Login />
          </PublicOnlyRoute>
        } 
      />
      <Route path="/changepassword/:token" element={<ChangePassword />} />
      
      {/* Protected routes */}
      <Route 
        path="/scenarios" 
        element={
          <ProtectedRoute>
            <Scenarios />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercises" 
        element={
          <ProtectedRoute>
            <Exercises />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercisescreate" 
        element={
          <ProtectedRoute>
            <ExerciseCreate />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercises/:id" 
        element={
          <ProtectedRoute>
            <Exercise />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercises/join/:id" 
        element={
          <ProtectedRoute>
            <ExerciseWaitingRoom />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/exercises/run/:id" 
        element={
          <ProtectedRoute>
            <ExerciseRun />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/webbuilder" 
        element={
          <ProtectedRoute>
            <WebBuilder />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mutual-aid" 
        element={
          <ProtectedRoute>
            <MutualAid />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/users" 
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/user" 
        element={
          <ProtectedRoute>
            <User />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/user/:id" 
        element={
          <ProtectedRoute>
            <User />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/companies" 
        element={
          <ProtectedRoute>
            <Companies />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/company" 
        element={
          <ProtectedRoute>
            <Company />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/company/:id" 
        element={
          <ProtectedRoute>
            <Company />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/blacklist" 
        element={
          <ProtectedRoute>
            <BlackList />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/help" 
        element={
          <ProtectedRoute>
            <Help />
          </ProtectedRoute>
        } 
      />
      <Route path="/logout" element={<Logout />} />
      
      {/* 404 route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}